import React, { Fragment } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import Cell from './Cell'
import CreateCashflowDatum from './queries/CreateCashflowDatum'
import processInput from './helpers/processInput'

const Container = styled.div`
  display: grid;
  grid-template-columns: ${props => props.inlineEdit ? 'repeat(5, 1fr)' : '2fr repeat(5, 1fr)'};
  /* flex-direction: row; */
  align-items: center;
  padding: 20px 10px 10px 0px;
`
const Link = styled.a`
  text-align: right;
  cursor: pointer;
`
const Cancel = Link.extend`
  width: 75%;
  text-align: left;
`
const Button = styled.button`
  color: white;
  background: #dd6a01;
  padding: 2px 0px;
  width: 75%;
  border-radius: 3px;
  border: none;
  &:disabled {
    background: #dddddd;
    cursor: default;
  }
`
const Select = styled.select`
  width: 100%;
`
const CellContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-self: start;
  grid-column-start: ${props => props.inlineEdit ? 1 : 2};
`
const Title = styled.b`
  position: absolute;
  white-space: nowrap;
  top: -70%;
  right: -20px;
`
const Reason = styled.textarea`
  grid-column-start: ${props => props.inlineEdit ? 1 : 2};
  grid-column-end: 6;
  width: 93.5%;
  padding: 4px 6px;
  justify-self: end;
  align-self: end;
  resize: none;
  margin: 10px 0px 0px 0px;
`
const Input = styled(Cell)`
  width: 100%;
`
const Controls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  grid-column-start: 6;
  grid-column-end: 6;
  text-align: center;
  margin-top: 8px;
`

class DebtAdjustment extends React.Component {
  constructor(props) {
    super(props)
    let data, reason
    if (props.inlineEdit && props.data[0]) {
      data = Math.floor(props.data[0].data / 12)
      reason = props.data[0].reason ? props.data[0].reason : ''
    } else {
      data = null
      reason = ''
    }
    this.state = {
      category: '1',
      isEditable: props.isEditable ? props.isEditable : false,
      data,
      reason,
      isButtonDisabled: true
    }
  }
  enableEdit = () => {
    this.setState({ isEditable: true })
  }
  disableEdit = () => {
    this.setState({ isEditable: false })
  }
  clear = () => {
    this.setState({ data: null, reason: '', isButtonDisabled: true, category: '1' })
  }
  validate = () => {
    const { availableCategories, inlineEdit } = this.props
    const { reason, category, data } = this.state
    let isButtonDisabled = true
    if (reason.length > 0 && category !== '1' && availableCategories.some(cat => cat.key === category) > -1 && data !== null) {
      isButtonDisabled = false
    } else if (reason.length > 0 && inlineEdit && data !== null) {
      isButtonDisabled = false
    }
    this.setState({ isButtonDisabled })
  }
  onSave = () => {
    const { createCashflowDatum, years, entityId, refetch, inlineEdit, onCancel } = this.props
    const mutations = []
    const { data, category, reason } = this.state
    for (const year of Array.from(years.keys())) {
      mutations.push(createCashflowDatum({
        variables: {
          input: {
            cashflowDatumFields: {
              data: data * 12,
              category: inlineEdit ? this.props.category : category,
              source: 'keyed',
              reason,
              resourceType: 'Guarantor',
              resourceId: entityId,
              year
            }
          }
        }
      }))
    }
    Promise.all(mutations).then(() => {
      this.clear()
      this.disableEdit()
      if (onCancel) {
        onCancel()
      }
      refetch()
    }).catch(err => {
      console.log(err)
    })
  }
  onChange = e => {
    this.setState({ category: e.target.value }, this.validate)
  }
  onCellChange = e => {
    this.setState({ data: processInput(e.target.value) }, this.validate)
  }
  onReasonChange = e => {
    this.setState({ reason: e.target.value }, this.validate)
  }
  onCancel = () => {
    this.disableEdit()
    this.clear()
    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }
  renderOptions = () => {
    const { availableCategories } = this.props
    return availableCategories.map(category => {
      return <option key={category.key} value={category.key}>{category.title}</option>
    })
  }
  renderEditableElements = () => {
    const { isEditable, isButtonDisabled, data, reason } = this.state
    const { inlineEdit } = this.props
    if (isEditable) {
      return (
        <Fragment>
          {
            !inlineEdit &&
            <Select id="add_debt_select" onChange={this.onChange}>
              <option value="1">Please Select a Category</option>
              {this.renderOptions()}
            </Select>
          }
          <CellContainer inlineEdit={inlineEdit}>
            <Input isEditable onChange={this.onCellChange} data={data} />
            <Title>Monthly Payment</Title>
          </CellContainer>
          <Reason id="add_debt_reason" value={reason} inlineEdit={inlineEdit}
            onChange={this.onReasonChange}
          />
          <Controls inlineEdit={inlineEdit}>
            <Button id="add_debt_save" disabled={isButtonDisabled} onClick={this.onSave}>Save</Button>
            <Cancel id="add_debt_cancel" onClick={this.onCancel}>Cancel</Cancel>
          </Controls>
        </Fragment>
      )
    }
  }
  renderLink = () => {
    if (!this.state.isEditable) {
      return (
        <Link id="add_debt_link" onClick={this.enableEdit}>Add Additional Category</Link>
      )
    }
  }
  render() {
    return (
      <Container id="add_debt">
        {this.renderEditableElements()}
        {this.renderLink()}
      </Container>
    )
  }
}

export default graphql(CreateCashflowDatum, {
  name: 'createCashflowDatum'
})(DebtAdjustment)
